
import Vue from 'vue';
import Vuex from 'vuex';
import tags from './modules/tags'
import user from './modules/user'
import upload from './modules/upload'
import machine from './modules/machine'
import menu from './modules/menu'
import getters from './getter'

Vue.use(Vuex);
const store= new Vuex.Store({
    modules:{
        tags,
        user,
        upload,
        machine,
        menu
    },
    getters
});

export default store



